import styled from 'styled-components';

import { COLORS } from '../../../../utils/styles';

export const Wrapper = styled.section`
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  margin: 10px auto;
  position: relative;
  height: 50px;
  width: 100%;
  overflow: hidden;
  border-bottom: 1px solid ${COLORS.darkerGray};
`;

export const ButtonsWrappers = styled.section`
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  margin: 1em 0px;
`;
export const Label = styled.label`
  color: ${({ isFilled, theme: { primaryColor } }) => (isFilled ? primaryColor : COLORS.slateGray)};
  bottom: 25px;
  font-size: 12px;
  position: absolute;
  pointer-events: none;
  transition: 0.1s ease-in-out;
  text-transform: uppercase;
`;

export const RawInput = styled.input`
  bottom: 0;
  width: 100%;
  border: none;
  outline: none;
  padding-bottom: 8px;
  font-size: 18px;
  position: absolute;
  background: transparent;
  transition: all 1s ease-in-out;
  font-family: 'Barlow', sans-serif;
  color: #7b7b7b;

  &::placeholder {
    font-family: 'Barlow', sans-serif;
    text-transform: capitalize;
    color: ${COLORS.darkerGray};
  }
`;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/Input/styled-components.js